import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_ANNOTATION',
    'FETCH_ANNOTATION_SUCCESS',
    'FETCH_ACTIVE_NOTES',
    'FETCH_ACTIVE_NOTES_SUCCESS',
    'FETCH_LIST',
    'FETCH_LIST_SUCCESS',
    'EDIT_NOTE',
    'CREATE_NOTE',
    'DELETE_NOTE',
    'DELETE_NOTE_SUCCESS',
    'TOGGLE_CREATE_NOTE_FORM'
], 'ANNOTATIONS');

// Action Creators
export const fetchAnnotation = createAction(actions.FETCH_ANNOTATION, params => params);
export const fetchAnnotationSuccess = createAction(actions.FETCH_ANNOTATION_SUCCESS, params => params);
export const fetchActiveNotes = createAction(actions.FETCH_ACTIVE_NOTES, params => params);
export const fetchActiveNotesSuccess = createAction(actions.FETCH_ACTIVE_NOTES_SUCCESS);
export const fetchList = createAction(actions.FETCH_LIST);
export const fetchListSuccess = createAction(actions.FETCH_LIST_SUCCESS);
export const editNoteForm = createFormAction(actions.EDIT_NOTE);
export const createNoteForm = createFormAction(actions.CREATE_NOTE);
export const deleteNote = createAction(actions.DELETE_NOTE);
export const deleteNoteSuccess = createAction(actions.DELETE_NOTE_SUCCESS);
export const toggleCreateNoteForm = createAction(actions.TOGGLE_CREATE_NOTE_FORM);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    showCreateForm: false,
    notes: {
        summary: [],
        display: [],
        mobile: [],
        native: [],
        video: [],
        sem: [],
        audio: [],
        social: [],
        tv: [],
        site: [],
        youtube: []
    },
    annotation: {}
};

export default handleActions({
    [actions.FETCH_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ANNOTATION_SUCCESS]: (state, action) => {
        const updatedData = {
            annotation: { $set: action.payload }
        };

        return update(state, updatedData);
    },
    [actions.FETCH_ACTIVE_NOTES_SUCCESS]: (state, action) => update(state, { $merge: { ...action.payload } }),
    [actions.DELETE_NOTE_SUCCESS]: state => update(state, {}),
    [actions.TOGGLE_CREATE_NOTE_FORM]: (state, action) => update(state, { showCreateForm: { $set: action.payload } }),
    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState }),
}, initialState);



// WEBPACK FOOTER //
// ./src/services/annotations/duck.js